

export const Constants = {
  COMPONENT_OPTIONS_KEY: "nuxtI18n",
  STRATEGIES: {"PREFIX":"prefix","PREFIX_EXCEPT_DEFAULT":"prefix_except_default","PREFIX_AND_DEFAULT":"prefix_and_default","NO_PREFIX":"no_prefix"},
  REDIRECT_ON_OPTIONS: {"ALL":"all","ROOT":"root","NO_PREFIX":"no prefix"},
}
export const nuxtOptions = {
  isUniversalMode: false,
  trailingSlash: undefined,
}
export const options = {
  vueI18n: {"fallbackLocale":"de","messages":{"de":{"common":{"member_id":"Mitgliedsnummer","alt_text":{"hb_logo":"Händlerbund Logo"}},"error":{"message":{"page_not_found":"Seite nicht gefunden","error_occurred":"Ein Fehler trat auf"}},"page":{"title":{"home":"Startseite"}}},"en":{"common":{"member_id":"Member ID","alt_text":{"hb_logo":"Händlerbund Logo"}},"error":{"message":{"page_not_found":"Page not found","error_occurred":"An error occurred"}},"page":{"title":{"home":"Home page"}}}}},
  vueI18nLoader: false,
  locales: ["de","en"],
  defaultLocale: "de",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  defaultLocaleRouteNameSuffix: "default",
  sortRoutes: true,
  strategy: "prefix_except_default",
  lazy: false,
  langDir: null,
  rootRedirect: null,
  detectBrowserLanguage: {"alwaysRedirect":false,"cookieAge":365,"cookieCrossOrigin":false,"cookieDomain":null,"cookieKey":"i18n_redirected","cookieSecure":false,"fallbackLocale":"","redirectOn":"root","useCookie":true},
  differentDomains: false,
  baseUrl: "",
  vuex: {"moduleName":"i18n","syncRouteParams":true},
  parsePages: true,
  pages: {},
  skipSettingLocaleOnNavigate: false,
  onBeforeLanguageSwitch: () => {},
  onLanguageSwitched: () => null,
  normalizedLocales: [{"code":"de"},{"code":"en"}],
  localeCodes: ["de","en"],
  additionalMessages: [],
}

export const localeMessages = {}
